import { render, staticRenderFns } from "./review-proposals-item.vue?vue&type=template&id=019b3dcb"
import script from "./review-proposals-item.vue?vue&type=script&lang=ts"
export * from "./review-proposals-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports